module.exports = __webpack_public_path__ + "assets/img/6_523_big.6895d86a.jpg";